import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styles: [
  ]
})
export class NotificationComponent implements OnInit {

  prompt: string = 'Message Text';
  okBtnClass: string = 'btn-primary';
  okBtnText: string = 'OK';
  okBtnIcon: string = null;

  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirmModal(): void {
    this.modal.close();
  }
}
